export default {
  id: 127,
  title: 'Target #127 - Letter I',
  url: 'https://cssbattle.dev/play/127',
  colors: ['#E3516E', '#FADE8B'],
  solution:
    '<a a><a b><a c><style>[b],body{background:#e3516e}[b],[c]{width:30}[a],[c]{top:70;background:#fade8b}a{position:fixed}[a]{left:165;width:70;height:160}[b]{top:100;left:155;height:100;border-radius:10px;box-shadow:60px 0 #e3516e}[c]{left:150;height:30;border-radius:9in;box-shadow:70px 0 #fade8b,110px 0 #fade8b,-40px 130px #fade8b,0 130px #fade8b,70px 130px #fade8b}</style>',
}
